// extracted by mini-css-extract-plugin
export default {"switchContainer":"switch_switchContainer__t4r9Z"};